export default __webpack_public_path__ + "static/media/down_arrow.b2f757eb.svg";